// extracted by mini-css-extract-plugin
module.exports = {"table":"EstimatedOrderSummary_table__ZV_kd","uppercase":"EstimatedOrderSummary_uppercase__1rIPt"};